import React, { Fragment, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import olympiadService from '../../services/olympiad.service';
import models_V2Service from '../../services/models_V2.service';
import ComponentTable from '../ComponentTable';
import AllTimeOlympiadChampions from './AllTimeOlympiadChampions';
import SwipeableViews from 'react-swipeable-views';
import { Tabs, Tab } from '@mui/material';

export default function FranchOlympiadParticipants() {
    const [index, setIndex] = useState(0);
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const parts = pathname.split('/').filter(Boolean);
    const period = parts[parts.length - 1] || null;

    return (
        <Fragment>
            <Tabs value={index} onChange={(e, value) => setIndex(value)} className="olymp_swipe">
                <Tab label={t('sidebar.olympiad')} />
                <Tab label={t('olympiad.victories')} />
            </Tabs>
            <SwipeableViews index={index} onChangeIndex={setIndex}>
                <div>
                    {index === 0 && (
                        <ComponentTable
                            source={{
                                getData: (page, size, sort, filter) =>
                                    olympiadService.GetOlympiadChampionsForPeriod(false, {
                                        page: page || 0,
                                        size: size || 10,
                                        orderBy: (sort && sort.orderBy) || null,
                                        order: (sort && sort.order) || 'asc',
                                        filter,
                                        period: period,
                                    }),
                                getModel: () => models_V2Service.getOlympiadChampionsForPeriod(false),
                            }}
                            actions={[]}
                            selectable={true}
                            enableFilter
                            title={t('modals.list')}
                            enableSettings
                            toolbarvisible={true}
                            typeTable="olympiadChampions"
                        />
                    )}
                </div>
                <div>{index === 1 && <AllTimeOlympiadChampions />}</div>
            </SwipeableViews>
        </Fragment>
    );
}
